import { PatientNonPathoCatalog, SaveDemographicPatient, SaveNotPathologicData, dataPatientByEmail, participantEmailsCountRequest, participantEmailsCountResponse, DiagnosticsCIECatalogI, fcUserCatalogItem, dataPatientProfileByUsername, fcUserCatalogAdditionalItem, ICustomNewCatalogItem, IfcUserCatalogRequest } from "@interfaces/fc-user/fc-user";
import axiosApiInstance from "@services/custom-axios-instance";
import axios from "axios";
import { generateUrl } from "@services/generateUrl/generateUrl";
import fcUserServiceApiInstance from "@services/clients/fc-user";
import { DemographicsI, IPatientProfile } from "@interfaces/patient/patient-profileI";

export function ParticipantCount(data: participantEmailsCountRequest) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/fcUser/participants/count`,
            data
        )
        .then((response) => {
            return response.data as participantEmailsCountResponse;
        });
}

/**
 * @deprecated Use `getDataPatientByUsernameNew` instead
 */
export async function getDataPatientByUsername(username: string) 
{
    const endpoint = `/person/patient/profile/${username}`
    const response = await fcUserServiceApiInstance.get<dataPatientProfileByUsername>(endpoint)
    return response.data
}

export async function getDataPatientByUsernameNew(username: string) 
{
    const endpoint = `/api/v1/person/patient/profile/${username}`
    const response = await fcUserServiceApiInstance.get<IPatientProfile>(endpoint)
    return response.data
}

export function getDataPatientByEmail(email: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/person/patient/profile/personal/information/${email}`,
        )
        .then((response) => {
            return response.data as dataPatientByEmail;
        });
}

export function getPatientAcademicEducation(lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/academic/education?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as PatientNonPathoCatalog[]
        })
}

/**
 * @deprecated Use the function in `catalogs`
 */
export function getPatientNationalities(lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/nationalities?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as PatientNonPathoCatalog[]
        })
}

/**
 * @deprecated Use the function in `catalogs`
 */
export function getPatientReligions(lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/religions?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as PatientNonPathoCatalog[]
        })
}
export function getPatientMaritalStatus(lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/maritalstatus?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as PatientNonPathoCatalog[]
        })
}

export function putNotPathological(data: SaveNotPathologicData){
    return axiosApiInstance
        .put(
            `${generateUrl()}/fcUser/person/patient/profile/demographic/not-pathological/`,
            data
        )
        .then((response) => {
            const res = response.data as unknown
            return res
        })
}
export function getDemographics(username: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/person/patient/profile/demographic/${username}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DemographicsI;
        });
}

export async function getNotPathological(username: string, personId?:string){
    let endpoint = `/person/patient/profile/demographic/not-pathological-username/${username}`
    const params = new URLSearchParams();
    if(personId)
        params.append("personId", String(personId));
    const strParams = params.toString();
    if(strParams)
        endpoint += `?${strParams}`;
    const response = await fcUserServiceApiInstance.get<SaveNotPathologicData>(endpoint)
    return response.data
}

export function putDemographicData(data: SaveDemographicPatient){
    return axiosApiInstance
        .put(
            `${generateUrl()}/fcUser/person/patient/profile/demographic/mongo`,
            data
        )
        .then((response) => {
            const res = response.data as unknown
            return res
        })
}

export function getDiagnosticsCIE(lang: string, lsex: string)
{
    const url = new URL(`${generateUrl()}/fcUser/catalog/diagnostics/${lsex}`)
    url.searchParams.set("lang", lang)
    return axiosApiInstance
        .get(url.toString())
        .then((response) => {
            const res = response.data as unknown
            return res as DiagnosticsCIECatalogI[]
        })
}

export function getCatalogMedicalDifficulties( lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/type/difficulties?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as fcUserCatalogItem[]
        })
}

export function getCatalogLevelDifficulties( lang: string){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/level/difficulties?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as fcUserCatalogItem[]
        })
}

export function getCatalogOriginDifficulties(lang: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcUser/catalog/origin/difficulties?lang=${lang}`
        )
        .then((response) => {
            const res = response.data as unknown
            return res as fcUserCatalogItem[]
        })
}

export async function getCatalogStudiesTag(request: IfcUserCatalogRequest) 
{
    let endpoint = `/catalog/studies/tags`
    const params = new URLSearchParams();
    params.append("lang", String(request.lang));
    if(request.gender)
        params.append("gender", String(request.gender));
    const strParams = params.toString();
    if(strParams)
        endpoint += `?${strParams}`;
    const response = await fcUserServiceApiInstance.get<fcUserCatalogAdditionalItem[]>(endpoint)
    return response.data
}

export async function getCustomCatalogStudiesTag(userId: number) 
{
    const url = `/catalog/custom/studies/tags/${userId.toString()}`
    const response = await fcUserServiceApiInstance.get<fcUserCatalogAdditionalItem[]>(url)
    return response.data
}

export async function saveCustomCatalogStudiesTag(data: ICustomNewCatalogItem) 
{
    const url = `/catalog/custom/studies/tags`
    const response = await fcUserServiceApiInstance.post<fcUserCatalogItem>(url, data)
    return response.data
}
export async function updatePractitionerEmail(email:string, personId:number) 
{
    const url = `/person/practitioner/email/${email}/${personId}`
    const response = await fcUserServiceApiInstance.put<string>(url)
    return response.data
}

/**
 * Update email to seeded practitioner account
 * @param email Email to add
 * @param personId Target person
 * @param token Required since it is possible that the token is not available in the axios instance
 */
export async function updatePractitionerEmailKc(email:string, personId:number, token:string)
{
    const url = `${generateUrl()}/fcUser/person/practitioner/email/${email}/${personId}`
    const response = await axios.put<string>(url,undefined,{headers: {Authorization: `Bearer ${token}`}})
    return response.data
}
